import { IsNotEmpty } from 'class-validator';

export class ServiceRejectFormData {
    @IsNotEmpty()
    rejectedReason: string;
}
